import api from './api.js';

export const issuerRolesAPI = {
  // Get all roles for the issuer
  getRoles: (params = {}) => api.get('/api/issuer-roles', { params }),
  
  // Get role statistics
  getRoleStats: () => api.get('/api/issuer-roles/stats'),
  
  // Get available permissions
  getAvailablePermissions: () => api.get('/api/issuer-roles/permissions'),
  
  // Get single role
  getRole: (roleId) => api.get(`/api/issuer-roles/${roleId}`),
  
  // Create new role
  createRole: (roleData) => api.post('/api/issuer-roles', roleData),
  
  // Update role
  updateRole: (roleId, roleData) => api.put(`/api/issuer-roles/${roleId}`, roleData),
  
  // Delete role
  deleteRole: (roleId) => api.delete(`/api/issuer-roles/${roleId}`),
  
  // Assign role to sub-account
  assignRoleToSubAccount: (roleId, subAccountId) => api.post('/api/issuer-roles/assign', { roleId, subAccountId }),
  
  // Remove role from sub-account
  removeRoleFromSubAccount: (subAccountId) => api.delete(`/api/issuer-roles/assign/${subAccountId}`),
  
  // Get pending role approval requests
  getPendingRoleApprovals: () => api.get('/api/issuer-roles/approval-requests/pending'),
  
  // Get role approval history
  getRoleApprovalHistory: (params = {}) => api.get('/api/issuer-roles/approval-requests/history', { params })
}; 